export default {
  'Resize for': 'تغيير الحجم لـ',
  'Add 10 videos at most': 'أضف 10 مقاطع فيديو على الأكثر.',
}